import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'RackScope',
    description: 'Walk into the data hall in 3D and explore every server, switch and storage system, rack by rack, with live health, power and temperature.',
    url: getOrigin()
}
